import { useState } from "react";
import { initial } from "../lib/format";

/**
 * Круглый портрет героя. Нет картинки или она не загрузилась — буква имени на
 * акцентном круге: пустой серый кружок на витрине выглядит поломкой.
 */
export function Avatar({ src, name, size = 48, className }: { src: string | null; name: string; size?: number; className?: string }) {
  const [failed, setFailed] = useState(false);
  const classes = ["avatar", className].filter(Boolean).join(" ");
  if (!src || failed) {
    return (
      <span className={`${classes} avatar--letter`} style={{ width: size, height: size, fontSize: size * 0.42 }} aria-hidden="true">
        {initial(name)}
      </span>
    );
  }
  return (
    <img
      className={classes}
      src={src}
      alt=""
      width={size}
      height={size}
      style={{ width: size, height: size }}
      onError={() => setFailed(true)}
      decoding="async"
    />
  );
}
